<template>
	<page>
		<module title="财务设置">
			<c-form ref="form">
				<c-form title="">
					<c-form-item type="radio" label="实名功能" name="F_CONFIG_USER_AUTH_ENABLED" :options="switchOptions"></c-form-item>
				</c-form>
			</c-form>

			<template slot="button">
				<c-button size="m" @click="saveHandle()">保存</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		name: 'm_finance_config',

		data() {
			return {
                editPriceCarryType:'OFF',
				switchOptions: [{
				    name: '开启',
				    value: 'ON'
				}, {
				    name: '关闭',
				    value: 'OFF'
				}],
				switchCostOptions: [{
					name: '商家平台共同承担',
					value: 'ON'
				}, {
					name: '平台独立承担',
					value: 'OFF'
				}]
			}
		},
		
		computed: {
			...mapState(['systemConfig']),
            priceEditWord() {
                return {
                    'ON': '【配置仅对‘收取服务费’商家生效】共同承担即调价后，商家收到的结算货款相应减少，平台抽取的服务费也相应减少。',
                    'OFF': '【配置仅对‘收取服务费’商家生效】由平台承担即调价行为不会影响商家收到的货款'
                }[this.editPriceCarryType]
            },
		},
		
		watch: {
			
		},

		mounted() {
			this.request({
				url: '/platform_config/list',
				data: {
				    config_group: ""
				},
				loading: true,
				success: data => {
					let json = {};
					data.forEach(function (item,i){
						json[item.config_item_code] = item.config_item_value;
					});
					this.$refs.form.set(json);
				}
			});
		},

		methods: {
			enabledHandle(state, data) {
				data.enabled = state;
				if (!state) {
					data.required = false;
				}
			},
			
			saveHandle() {
				this.$refs.form.submit({
					url: '/platform_config/edit',
					dataFormatter: data => {
						let arr = [];
						for (let key in data) {
							arr.push({
								config_item_code: key.toUpperCase(),
								config_item_value: data[key].toString()
							});
						}
						return {
							platform_config_list: arr
						};
					},
					success: () => {
						this.$store.dispatch('getSystemConfig');
						this.$message({
							text: '操作成功'
						});

					}
				});
			}
		}
	}
</script>
<style lang="stylus" scoped>

</style>